import * as React from "react";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Facebook, Instagram, Twitter, YouTube } from "@mui/icons-material";
import { Container } from "@mui/material";

export default function Footer() {
  return (
    <Box
      sx={{
        background:
          "linear-gradient(180deg, rgba(37,37,37,1) 0%, rgba(51,51,51,1) 60%, rgba(37,37,37,1) 100%)",
        color: "white",
        textAlign: "center",
        padding: { xs: "20px", md: "28px" },
        boxShadow: "inset 0 6px 18px rgba(0,0,0,0.25)",
      }}
    >
      <Container>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ fontWeight: 800, letterSpacing: 1, fontSize: { xs: 24, md: 30 } }}
        >
          Stay Connected
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 2,
            gap: 1,
          }}
        >
          <Link
            href="https://www.facebook.com/PunjabiwithDkSaini/"
            target="_blank"
            rel="noopener"
            color="inherit"
            underline="none"
            sx={{
              border: "1px solid rgba(255,255,255,0.8)",
              borderRadius: "100%",
              background: "rgba(255,255,255,0.08)",
              transition: "transform .2s ease, background .2s ease",
              "&:hover": { transform: "translateY(-2px)", background: "rgba(255,255,255,0.14)" },
              "&:focus-visible": { outline: "3px solid #fff", outlineOffset: 3 },
            }}
            aria-label="Visit our Facebook (opens in a new tab)"
          >
            <IconButton color="inherit">
              <Facebook />
            </IconButton>
          </Link>
          <Link
            href="https://twitter.com/devinderKaurSa2"
            target="_blank"
            rel="noopener"
            color="inherit"
            underline="none"
            sx={{
              border: "1px solid rgba(255,255,255,0.8)",
              borderRadius: "100%",
              background: "rgba(255,255,255,0.08)",
              transition: "transform .2s ease, background .2s ease",
              "&:hover": { transform: "translateY(-2px)", background: "rgba(255,255,255,0.14)" },
              "&:focus-visible": { outline: "3px solid #fff", outlineOffset: 3 },
            }}
            aria-label="Visit our Twitter (opens in a new tab)"
          >
            <IconButton color="inherit">
              <Twitter />
            </IconButton>
          </Link>
          <Link
            href="https://www.instagram.com/devinderksaini/"
            target="_blank"
            rel="noopener"
            color="inherit"
            underline="none"
            sx={{
              border: "1px solid rgba(255,255,255,0.8)",
              borderRadius: "100%",
              background: "rgba(255,255,255,0.08)",
              transition: "transform .2s ease, background .2s ease",
              "&:hover": { transform: "translateY(-2px)", background: "rgba(255,255,255,0.14)" },
              "&:focus-visible": { outline: "3px solid #fff", outlineOffset: 3 },
            }}
            aria-label="Visit our Instagram (opens in a new tab)"
          >
            <IconButton color="inherit">
              <Instagram />
            </IconButton>
          </Link>
          <Link
            href="https://www.youtube.com/@PunjabiAudiobooksByDKSaini"
            target="_blank"
            rel="noopener"
            color="inherit"
            underline="none"
            sx={{
              border: "1px solid rgba(255,255,255,0.8)",
              borderRadius: "100%",
              background: "rgba(255,255,255,0.08)",
              transition: "transform .2s ease, background .2s ease",
              "&:hover": { transform: "translateY(-2px)", background: "rgba(255,255,255,0.14)" },
              "&:focus-visible": { outline: "3px solid #fff", outlineOffset: 3 },
            }}
            aria-label="Visit our YouTube (opens in a new tab)"
          >
            <IconButton color="inherit">
              <YouTube />
            </IconButton>
          </Link>
        </Box>
        <Box sx={{ marginTop: 2 }}>
          <Typography variant="body1" gutterBottom>
            &copy; {new Date().getFullYear()} sainiaudiobooks&nbsp; All rights
            reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
